import {
    Grid, makeStyles, Paper, Tooltip, Typography,
} from '@material-ui/core';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import CountUp from 'react-countup';

const styles = makeStyles(({ spacing, palette }) => ({
    root: {
        padding: spacing(2),
    },
    white: {
        // background: '#fff',
    },
    red: {
        background: palette.primary.main,
    },
    blue: {
        background: palette.secondary.main,
    },
    green: {
        background: palette.green,
    },
    textWhite: {
        color: 'white',
    },
    pointer: {
        cursor: 'pointer',
    },
    label: {
        letterSpacing: 1,
    },
}));

const propTypes = {
    prefix: PropTypes.bool,
    label: PropTypes.string.isRequired,
    value: PropTypes.number,
    variant: PropTypes.oneOf(['outlined', 'elevation']),
    elevation: PropTypes.number,
    color: PropTypes.oneOf(['white', 'green', 'blue', 'red']),
};

const defaultProps = {
    color: 'white', elevation: 4, prefix: false, value: 0, variant: 'elevation',
};

function Widget({
    label, elevation, value, variant, helperText, color, onClick, prefix,
}) {
    const classes = styles();

    return (
        <Paper
            elevation={elevation}
            className={cx(classes.root, classes[color], onClick && classes.pointer)}
            onClick={onClick}
            variant={variant}
        >
            <Typography variant="overline" className={cx(classes.label, color !== 'white' ? classes.textWhite : '')}>
                {label}
            </Typography>
            <Grid container justify="space-between">
                <Typography variant="h5" color="inherit" className={color !== 'white' && classes.textWhite}>
                    {!isNaN(value)
                        ? (
                            <>
                                {prefix ? 'Rp. ' : ''}
                                <CountUp
                                    useEasing
                                    start={0}
                                    end={value}
                                    duration={2}
                                    separator=","
                                />
                            </>
                        ) : value}
                </Typography>
                {helperText && (
                    <Tooltip title={helperText} aria-label={helperText}>
                        <InfoIcon className={color !== 'white' && classes.textWhite} />
                    </Tooltip>
                )}

            </Grid>

        </Paper>
    );
}

Widget.propTypes = propTypes;
Widget.defaultProps = defaultProps;

export default Widget;
